import { Feature } from "ol";
import { FeatureGeoJson } from "./FeatureGeoJson";
import { AttributeType } from "./define/AttributeType";
import { IAttributeConvert } from "@/attribute/convert/IAttributeConvert";
import { ISearchDateAttributeConvert } from "@/attribute/convert/ISearchDateAttributeConvert";
import { IAttributeImageConvert } from "@/attribute/convert/IAttributeImageConvert";

/**
 * 選択地物クラス
 */
export class SelectedFeatureInfo {
  /**
   * 選択地物
   */
  selectFeature: Feature;

  /**
   * コンテキストメニュー名
   */
  contextMenuName: string;

  /**
   * 地物属性json
   */
  featureGeoJson: FeatureGeoJson;

  /**
   * 属性タイプ
   */
  attributeType: AttributeType;

  /**
   * 属性コンバータ
   */
  attributeConvert:
    | ISearchDateAttributeConvert
    | IAttributeConvert
    | IAttributeImageConvert;

  /**
   * WMS選択地物かVectorの選択地物かを示す。(trueの場合はWMS地物)
   */
  isSelectedFeatureWms: boolean;

  /**
   * WMS選択表示用のレイヤ名
   */
  wmsLayerName: string;

  /**
   * WMS選択表示用のスタイル名
   */
  wmsStyle: string;

  /**
   * WMS選択地物
   */
  wmsFid: string;

  /**
   * 選択地物グループインデックス
   */
  groupIndex: number;

  /**
   * CQLパラメータ
   */
  cqlParameter: string;

  /**
   * コンテキストメニュークリック時追加処理
   */
  clickMenuItemAction?: () => void;

  /**
   * 選択地物コンストラクタ
   * @param selectFeature 選択地物
   * @param contextMenuName コンテキストメニュー名
   * @param attributeType 属性タイプ
   * @param attributeConvert attributeConvert
   * @param isSelectedFeatureWms WMS選択地物かVector選択地物かを示す。
   * @param wmsLayerName WMS選択用レイヤ名
   * @param wmsStyle WMS選択表示用スタイル
   * @param wmsFid WMS選択対象地物ID
   * @param cqlParameter CQLパラメータ
   */
  constructor(
    selectFeature: Feature,
    contextMenuName: string,
    featureGeoJson: FeatureGeoJson,
    attributeType: AttributeType,
    attributeConvert?: ISearchDateAttributeConvert | IAttributeConvert,
    isSelectedFeatureWms?: boolean,
    wmsLayerName?: string,
    wmsStyle?: string,
    wmsFid?: string,
    cqlParameter?: string,
    groupIndex?: number,
    clickMenuItemAction?: () => void
  ) {
    this.selectFeature = selectFeature;
    this.contextMenuName = contextMenuName;
    this.featureGeoJson = featureGeoJson;
    this.attributeType = attributeType;
    this.attributeConvert = attributeConvert;
    this.isSelectedFeatureWms = isSelectedFeatureWms;
    this.wmsLayerName = wmsLayerName;
    this.wmsStyle = wmsStyle;
    this.wmsFid = wmsFid;
    this.cqlParameter = cqlParameter;
    this.groupIndex = groupIndex;
    this.clickMenuItemAction = clickMenuItemAction;
  }
}
